var map = {
	"./de.json": 888,
	"./en.json": 889,
	"./es.json": 890,
	"./fr.json": 891,
	"./it.json": 892,
	"./ja.json": 893,
	"./nl.json": 894,
	"./pt.json": 895,
	"./zh.json": 896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;